import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/flames-calculator/page.tsx");
